import React from 'react';
import ItServicesHero from '../components/ItServicesHero';
import LeadingItServicesSection from '../components/LeadingItServicesSection';
import ItServicesTabs from '../components/ItServicesTabs';
import WhyChooseItConsulting from '../components/WhyChooseItConsulting';
import Counters from '../components/Counters';
import ItServicesDifferentiators from '../components/ItServicesDifferentiators';
import DigitalMarketingLogosSlider from '../components/DigitalMarketingLogosSlider';
import ItServicesTestimonialsSlider from '../components/ItServicesTestimonialsSlider';
import ContactUs from '../components/ContactUs';

const clientsServedIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const successfulProjectsIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
    <polyline points="9.5 11.5 7.5 13 9.5 14.5" />
    <polyline points="14.5 11.5 16.5 13 14.5 14.5" />
    <line x1="13" y1="10.5" x2="11" y2="15.5" />
  </svg>
);

const ratingIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="6" r="3.5" />
    <path d="M7 16c0-2.5 2.2-4 5-4s5 1.5 5 4" />
    <polygon points="12,14 13,16.5 15.5,16.8 13.5,18.5 14,21 12,19.5 10,21 10.5,18.5 8.5,16.8 11,16.5" />
    <polygon points="6,16 6.8,17.8 8.8,18 7.4,19.4 7.8,21.4 6,20.4 4.2,21.4 4.6,19.4 3.2,18 5.2,17.8" />
    <polygon points="18,16 18.8,17.8 20.8,18 19.4,19.4 19.8,21.4 18,20.4 16.2,21.4 16.6,19.4 15.2,18 17.2,17.8" />
  </svg>
);

const experienceIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="14" width="3" height="7" rx="0.5" />
    <rect x="8" y="10" width="3" height="11" rx="0.5" />
    <rect x="13" y="6" width="3" height="15" rx="0.5" />
    <rect x="18" y="2" width="3" height="19" rx="0.5" />
    <path d="M3 10c4-4 10-7 18-7m0 0v5m0-5h-5" />
  </svg>
);

const itCountersData = [
  { target: 100, suffix: '+', text: 'Clients Served', icon: clientsServedIcon },
  { target: 300, suffix: '+', text: 'Successful Projects', icon: successfulProjectsIcon },
  { target: 4.8, decimals: 1, text: 'Rating', icon: ratingIcon },
  { target: 10, suffix: '+', text: 'Years of Experience', icon: experienceIcon }
];

function ItServicesPage({ setView }) {
  return (
    <>
      <ItServicesHero />
      <LeadingItServicesSection setView={setView} />
      <ItServicesTabs />
      <WhyChooseItConsulting />
      <Counters data={itCountersData} />
      <ItServicesDifferentiators />
      <DigitalMarketingLogosSlider />
      <ItServicesTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default ItServicesPage;
